module.exports = __webpack_public_path__ + "static/media/wedoverify-gif.dd487cfd.gif";